import { Bill, BillingType, BillStatus } from '../../../../generated'

export interface FinalBillsFilters {
  attorneyId?: string
  lawTypeId?: string
  caseType?: BillingType
  status?: BillStatus | 'all'
  searchTerm?: string
  isDelinquentBills?: boolean
  billDeliveryType?: string
  sentStatus?: boolean
  onlyWithTrust?: boolean
  onlyWithCredit?: boolean
}

export interface FinalBillsState {
  bills: Bill[]
  loading: boolean
}

export const finalBillsInitialState: FinalBillsState = {
  bills: [],
  loading: false
}

export enum FinalBillsActionType {
  SET_FINAL_BILLS = 'setFinalBills',
  SET_LOADING = 'setLoading'
}

export type FinalBillsAction =
  | { type: FinalBillsActionType.SET_FINAL_BILLS; bills: Bill[] }
  | { type: FinalBillsActionType.SET_LOADING; loading: boolean }

export const finalBillsReducer = (state: FinalBillsState, action: FinalBillsAction): FinalBillsState => {
  switch (action.type) {
    case FinalBillsActionType.SET_FINAL_BILLS:
      return {
        ...state,
        bills: action.bills
      }

    case FinalBillsActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    default:
      return state
  }
}
